"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShortestRouteHacky = exports.getShortestRoute = void 0;
var minBy_1 = __importDefault(require("lodash/minBy"));
var helpers_1 = require("@turf/helpers");
var nearest_point_on_line_1 = __importDefault(require("@turf/nearest-point-on-line"));
var length_1 = __importDefault(require("@turf/length"));
var find_many_1 = __importDefault(require("./find-many"));
var flatten_1 = __importDefault(require("lodash/flatten"));
var utils_1 = require("./utils");
function getShortestRoute(_a) {
    var graph = _a.graph, waypoints = _a.waypoints, pathFinderOptions = _a.pathFinderOptions, options = _a.options, newPosition = _a.newPosition;
    // Ensure that there's sufficient waypoints in the array
    if (waypoints.length < 2) {
        throw new Error("There must be at least 2 waypoints, 1 for the vessel and 1 for the destination.");
    }
    // Calculate the original route
    var originalRoute = (0, find_many_1.default)(graph, waypoints, pathFinderOptions, options);
    if (!originalRoute) {
        throw new Error("An error occured with the provided waypoints.");
    }
    // build the different permutations
    var permutations = Array.from({ length: waypoints.length }, function (o, i) { return i; }).reduce(function (all, _, index) {
        var newArray = __spreadArray([], waypoints, true);
        newArray.splice(index + 1, 0, newPosition);
        all.push({ waypoints: newArray, position: index + 1 });
        return all;
    }, []);
    // console.time('compute');
    // Compute distances for each permutation
    var computedDistances = permutations.reduce(function (complete, permutation) {
        var compute = (0, find_many_1.default)(graph, permutation.waypoints, pathFinderOptions, options);
        if (compute) {
            complete.push(__assign(__assign({}, compute), { position: permutation.position, finalWaypoints: permutation.waypoints, distanceDeviation: compute.distance - originalRoute.distance }));
        }
        return complete;
    }, []);
    // Pick shortest
    var shortest = (0, minBy_1.default)(computedDistances, "distance");
    // console.timeEnd('compute');
    return __assign(__assign({}, shortest), { distanceOriginal: originalRoute.distance });
}
exports.getShortestRoute = getShortestRoute;
function getShortestRouteHacky(_a) {
    var existingPath = _a.existingPath, newPosition = _a.newPosition, units = _a.units;
    // console.time('compute');
    var flattenedPath = (0, flatten_1.default)(existingPath);
    var properties = (0, nearest_point_on_line_1.default)((0, helpers_1.feature)({ type: "LineString", coordinates: flattenedPath }), newPosition, {
        units: units,
    }).properties;
    var selectedIndex = properties.index;
    if (selectedIndex === undefined) {
        throw new Error("Unable to locate a point");
    }
    // The coordinates of the line segment is (index, index + 1)
    // In situations where the index is the last item in the path, it will be (index - 1, index)
    var indexToInsert = selectedIndex + 1;
    if (!flattenedPath[selectedIndex + 1]) {
        indexToInsert = selectedIndex - 1;
    }
    var newPath = (0, utils_1.insertIntoArray)(flattenedPath, newPosition, indexToInsert);
    var oriDistance = (0, length_1.default)((0, helpers_1.feature)({ type: "LineString", coordinates: flattenedPath }), { units: units });
    var newDistance = (0, length_1.default)((0, helpers_1.feature)({ type: "LineString", coordinates: newPath }), { units: units });
    // console.timeEnd('compute');
    return {
        path: newPath,
        deviationDistance: newDistance - oriDistance,
    };
}
exports.getShortestRouteHacky = getShortestRouteHacky;
